export default {
    NOVO: 1,
    ANTIGO: 2,
}